import { render } from "./BlockModal.vue?vue&type=template&id=be14d84e"
import script from "./BlockModal.vue?vue&type=script&lang=js"
export * from "./BlockModal.vue?vue&type=script&lang=js"

import "./BlockModal.vue?vue&type=style&index=0&id=be14d84e&lang=css"
script.render = render

export default script